var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C12.5523 1.5 13 1.94772 13 2.5V7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7V2.5C11 1.94772 11.4477 1.5 12 1.5ZM6 4C6.55228 4 7 4.44772 7 5V7C7 7.55228 6.55228 8 6 8C5.44772 8 5 7.55228 5 7V5C5 4.44772 5.44772 4 6 4ZM18 4C18.5523 4 19 4.44772 19 5V7C19 7.55228 18.5523 8 18 8C17.4477 8 17 7.55228 17 7V5C17 4.44772 17.4477 4 18 4ZM2.5 11C2.5 10.4477 2.94772 10 3.5 10H20.5C21.0523 10 21.5 10.4477 21.5 11C21.5 14.9307 19.3513 18.063 16.2385 19.5532L16.9487 21.6838C17.0503 21.9887 16.9992 22.3239 16.8112 22.5847C16.6233 22.8455 16.3214 23 16 23H8C7.67856 23 7.37671 22.8455 7.18876 22.5847C7.00081 22.3239 6.94967 21.9887 7.05132 21.6838L7.76149 19.5532C4.64875 18.063 2.5 14.9307 2.5 11ZM9.64656 20.2226L9.38743 21H14.6126L14.3534 20.2226C13.6002 20.4046 12.8116 20.5 12 20.5C11.1884 20.5 10.3998 20.4046 9.64656 20.2226ZM4.55917 12C5.02311 15.8602 8.15966 18.5 12 18.5C15.8403 18.5 18.9769 15.8602 19.4408 12H4.55917Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoups);
export default __webpack_public_path__ + "static/media/soups.116eaf52f6fa333f5ed8fceeebf3e072.svg";
export { ForwardRef as ReactComponent };